export default "/images/lab-icon.svg?1e97940561dc36a399582af0d91c08c8";